import script from "./AdultsCounterComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdultsCounterComponent.vue?vue&type=script&setup=true&lang=ts"

import "./AdultsCounterComponent.vue?vue&type=style&index=0&id=ee718576&lang=css"

const __exports__ = script;

export default __exports__